import { jsx as _jsx } from "react/jsx-runtime";
/**
 * THIS IS AN AUTO-GENERATED FILE FROM SVGR. DO NOT MODIFY!
 *
 * File was made using the 'rushx build:icons' command.
 * To learn more see the {@link https://github.com/seequent/user-portal/blob/master/libraries/web-design-system-2/README.md#making-icons-|ReadMe}
 */
import SvgIcon from '@mui/material/SvgIcon';
import { createElement } from 'react';
function SvgInfoIcon(props) {
    return createElement(SvgIcon, Object.assign({ style: { width: '1em', height: '1em' }, viewBox: '0 0 24 24' }, props), _jsx("path", { fill: "currentColor", fillOpacity: 0.9, fillRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16m-1-3.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm.5-9.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z", clipRule: "evenodd" }));
}
export default SvgInfoIcon;
//# sourceMappingURL=Info.js.map